import React, { Component } from 'react'
import NetworkData from '../../../../../../actions/StaticApi/NetworkData';

class ProfileIMG extends Component {
    constructor(props) {
        super(props)
        this.state = {
            picture: this.props.pic.replace(/\s/g, ''),
            network: this.findNetwork(props)
        }
    }
    findNetwork = (props) => {
        const { item } = props
        if (NetworkData && NetworkData.length > 0) {
            const data = NetworkData.filter((nItem) => String(nItem.name).toLowerCase() == String(this.props.pic.networkId).toLowerCase())
            if (data && data.length > 0) return data[0];
            else return "#000";
        }
        else return "#000";
    }
    render() {
        const { pic, cssclassName, accountName } = this.props;
        const { picture, network } = this.state;
        return <>
            <span className={cssclassName} err-PICTURE data-original={pic} data-name={accountName}
                style={{ backgroundImage: `url(${picture.replace(/\s/g, '')})` }}>
            </span>
            <img src={pic.replace(/\s/g, '')} onError={event => this.setState({ picture: `https://ui-avatars.com/api/?name=${accountName.replace(/\s/g, '')}&background=000&color=fff&length=1` })} style={{ display: 'none' }} />
        </>


    }
}

export default ProfileIMG;